import React from "react";
import DocumentTitle from "react-document-title";
import {UploadFiles} from "../../modules/UploadFiles";
import {UploadType} from "../../static/enums/UploadType";
import {Route, Switch} from "react-router-dom";
import {DefaultRoutes, SkillsRoutes} from "../../routes";
import {SkillsTable} from "../../modules/SkillsTable";
import {FeatureAppearance} from "../../modules/FeatureAppearance";
import {Redirect} from "react-router";

export default function TopicsPage() {
    return (
        <DocumentTitle title={"Навыки - Mindset.Digital"}>
            <Switch>
                <Route exact path={`/${DefaultRoutes.skills}`} component={SkillsTable}/>
                <Route
                    path={`/${SkillsRoutes.files}`}
                    component={UploadSkillsFiles}
                />
            </Switch>
        </DocumentTitle>
    );
}

function UploadSkillsFiles() {
  return (
    <FeatureAppearance feature={["questions.skills.any.create", "questions.skills.any.update"]}>
      {(featureExist) => {
        return featureExist
          ? (
            <div>
              <UploadFiles title={"XLS-файл с навыками"} type={UploadType.skills}/>
            </div>
          )
          : <Redirect to={"/page404"} />
      }}
    </FeatureAppearance>
  )
}